<template>
  <div>
    <div
      v-if="showSuccessPage"
      class="top-up-success"
    >
      <top-up-success
        :amount="amount"
        :transfer="transfer"
        :coin-type="paymentMethod.value"
        :show-success-page.sync="showSuccessPage"
        :payment-method="paymentMethod"
      />
    </div>
    <div v-else>
      <div
        class="bg-white list-card p-2"
        :class="hasStepGuide ? 'border-content' : ''"
        data-testid="redotpay-follow-instruction-section"
      >
        <div>
          <h4
            class="mb-2"
            data-testid="redotpay-follow-instruction-title"
          >
            {{ $t('payment.wiseTransfer.titleFollowInstruction') }}
          </h4>

          <div class="mt-1 d-flex">
            <div class="step-number">
              1
            </div>
            <p
              data-testid="content-instruction-1-redotpay"
              class="font-14 font-weight-600 mb-0"
            >
              {{ $t('guidePopUp.guideTopUpUSDT.thirdContentGuide') }}
            </p>
          </div>

          <div
            data-testid="content-wallet-redotpay"
            class="wallet-content"
          >
            <wallet-input :transfer="transfer" />
            <hr class="horizontal-divide">
            <!-- transfer network -->
            <b-row>
              <b-col md="4">
                <label
                  data-testid="label-redotpay-wallet-address"
                  class="font-14"
                >
                  {{ $t('payment.USDT.labelTransferNetwork') }}
                </label>
              </b-col>
              <b-col
                data-testid="transfer-network-wallet-redotpay"
                md="8"
              >
                <strong
                  data-testid="transfer-value-wallet-redotpay"
                  class="mr-1"
                >
                  {{ transfer.value }}
                </strong>
                <span data-testid="transfer-name-wallet-redotpay">
                  {{ transfer.name }}
                </span>
              </b-col>
            </b-row>
            <!-- total amount -->
            <b-row class="mt-1">
              <b-col md="4">
                <label
                  data-testid="label-total-amount-wallet-redotpay"
                  class="font-20"
                >
                  {{ $t('addFundPage.creditCardPayment.textTotalAmount') }}
                </label>
              </b-col>
              <b-col
                data-testid="total-amount-wallet-redotpay"
                md="8"
              >
                <strong
                  data-testid="amount-wallet-redotpay"
                  class="mr-1 total-amount"
                >
                  {{ totalAmount }}
                </strong>
                <strong
                  data-testid="currency-redotpay"
                  class="font-20"
                >
                  {{ paymentMethod.value }}
                </strong>
              </b-col>
            </b-row>
            <hr class="horizontal-divide">
            <div data-testid="content-note-info-wallet-redotpay">
              <p
                style="margin-bottom: 4px"
                data-testid="title-note-info-wallet-redotpay"
              >
                {{ $t('payment.USDT.titleNoteInfoUSDT') }}:
              </p>
              <p
                data-testid="text-first-note-info-wallet-redotpay"
                class="point"
              >
                {{ $t('payment.USDT.firstNoteInfoUSDT', {payment: paymentMethod.value}) }}
              </p>
              <div
                data-testid="text-second-note-info-wallet-redotpay"
                class="point"
              >
                <span>🔥 {{ $t('payment.USDT.secondNoteInfoUSDT') }} </span>
                <span
                  v-if="!transfer.name"
                  data-testid="transfer-value-note-info-wallet-redotpay"
                  class="font-weight-600"
                >
                  {{ transfer.value }}
                </span>
                <span
                  v-else
                  data-testid="transfer-name-note-info-wallet-redotpay"
                  class="font-weight-600"
                >
                  {{ transfer.name }}
                </span>
              </div>
            </div>
          </div>

          <div class="mt-2 d-flex">
            <div class="step-number">
              2
            </div>
            <p
              data-testid="content-instruction-2-redotpay"
              class="font-14 font-weight-600"
            >
              {{ $t('payment.USDT.secondFollowInstruction') }}
            </p>
          </div>
          <div :class="hasStepGuide ? 'top-up-on-step' : 'top-up-form-container'">
            <div
              class="add-fund-form"
            >
              <validation-observer ref="formValidation">
                <b-form
                  data-testid="transactions-form-redotpay"
                  class="transactions-form"
                >
                  <b-form-group
                    :label="$t('payment.wiseTransfer.labelIDTransactions')"
                    data-testid="label-id-transactions-redotpay"
                    class="position-relative form-label"
                  >
                    <validation-provider
                      #default="{ errors }"
                      id="transactions-redotpay"
                      :name="$t('payment.wiseTransfer.labelIDTransactions')"
                      rules="required"
                    >
                      <b-input-group
                        class="input-group-merge width-custom w-100"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                      >
                        <b-form-input
                          v-model="transactionId"
                          class="input-height"
                          data-testid="redotpay-transaction-id-input"
                          placeholder="EX: 123456789"
                          :state="errors.length > 0 ? false : null"
                        />
                      </b-input-group>
                      <small
                        v-if="errors[0]"
                        class="text-danger"
                        data-testid="redotpay-transaction-id-error"
                      >
                        {{ errors[0] }}
                      </small>
                    </validation-provider>

                    <div class="mt-2">
                      <p
                        class="d-flex align-items-center upload"
                        data-testid="redotpay-upload-attachment-btn"
                        @click="$refs.refImage.$el.click()"
                      >
                        <b-img
                          fluid
                          alt="img"
                          :src="
                            require('@/assets/images/pages/payment/ic-attachment-white.svg')
                          "
                        />
                        <span data-testid="placeholder-upload-img-redotpay">
                          {{ $t('payment.wiseTransfer.placeHolderUploadImg') }}
                          <span
                            data-testid="type-upload-img-redotpay"
                            class="font-14"
                          >(PDF, JPG, PNG)
                          </span>
                        </span>
                      </p>
                      <b-form-file
                        v-model="imageFile"
                        ref="refImage"
                        plain
                        accept=".jpg, .png, .pdf"
                        :hidden="true"
                        @input="inputImageRenderer"
                      />

                      <p
                        v-if="fileUrl && imageFile && imageFile.name"
                        data-testid="text-valid-image-file"
                        class="form-label font-small-2 text-success"
                        style="margin-top: 5px"
                      >
                        <span>{{
                          `${ $t('payment.wiseTransfer.textUploaded') } ${imageFile.name || fileUrl.name} ${ $t('payment.wiseTransfer.textSuccess') }!`
                        }}</span>
                      </p>

                      <small
                        v-if="imageError"
                        data-testid="text-error-image-file"
                        class="text-danger"
                      >
                        {{ $t('payment.wiseTransfer.errorRequiredAttachment') }}
                      </small>
                    </div>

                    <slide-step
                      class="mt-2"
                      :step="2"
                    />
                    <div
                      class="
                        d-flex
                        justify-content-between
                        font-14 font-medium
                        mb-2
                      "
                    >
                      <span data-testid="content-step2-redotpay">
                        {{ $t('payment.wiseTransfer.placeHolderUploadImg') }}
                      </span>
                      <span>2/2</span>
                    </div>

                    <div
                      class="d-flex align-items-center justify-content-end mt-2"
                    >
                      <btn-loading
                        id="trigger-back-redotpay"
                        class="mr-1 border-0"
                        variant-convert="btn-back"
                        pill
                        @click.prevent="handleClickPrev"
                      >
                        {{ $t('stepGuideControl.stepVerifyInfo.textBack') }}
                      </btn-loading>
                      <btn-loading
                        id="trigger-top-up-redotpay"
                        span-id="trigger-top-up-redotpay-child"
                        class="btn-height btn-text-color"
                        variant-convert="btn-submit"
                        pill
                        :loading="loading || paymentLoading"
                        @click.prevent="submit"
                      >
                        {{ $t('guidePopUp.guideTopUpWise.textDone') }}
                      </btn-loading>
                    </div>
                  </b-form-group>
                </b-form>
              </validation-observer>
            </div>

            <div class="line-center">
              <div class="horizontal-divide" />
            </div>

            <div
              data-testid="summary-step2-redotpay-form"
              class="summary-form"
            >
              <summary-amount
                :amount="amount"
                :payment-method="paymentMethod"
                :transfer="transfer"
                :amount-tip="amountTip || 0"
                :current-tip="currentTip || 0"
                :show-tips-input="showTipsInput"
                :transaction-type="transactionType"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  VBTooltip,
  BFormInput,
  BInputGroup,
  BFormGroup,
  BForm,
  BImg,
  BFormFile,
} from 'bootstrap-vue'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import paymentMixin from '@/mixins/paymentMixin'
import gaTrackingMixin from '@/mixins/gaTrackingMixin'
import envMixin from '@/mixins/envMixin'
import generalConfigsMixin from '@/mixins/generalConfigsMixin'
import numberFormatMixin from '@/mixins/numberFormatMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import { toastification } from '@core/mixins/toast'
import { mapGetters, createNamespacedHelpers } from 'vuex'

import { ref } from '@vue/composition-api'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { PAYMENT_METHOD, TICKET_TYPE, TRANSACTION_TYPE } from '@/constants'
import SlideStep from '../SlideStep.vue'
import SummaryAmount from './Summary.vue'
import WalletInput from './WalletInput.vue'
import TopUpSuccess from './TopUpSuccess.vue'

const { mapActions } = createNamespacedHelpers('file')
const { mapActions: mapPaymentActions } = createNamespacedHelpers('payment')

export default {
  components: {
    BRow,
    BCol,
    BtnLoading,
    BFormInput,
    BInputGroup,
    BFormGroup,
    BImg,
    BFormFile,
    BForm,
    ValidationProvider,
    ValidationObserver,
    SummaryAmount,
    WalletInput,
    TopUpSuccess,
    SlideStep,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  mixins: [
    paymentMixin,
    generalConfigsMixin,
    numberFormatMixin,
    toastification,
    stepGuideMixin,
    gaTrackingMixin,
    envMixin,
  ],

  props: {
    paymentMethod: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },

    transfer: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },

    amount: {
      type: Number,
      required: true,
    },

    account: {
      type: Object,
      required: true,
    },

    // isToggle: {
    //   type: Boolean,
    //   required: true,
    // },

    transactionInfo: {
      type: String,
      required: true,
    },

    billing: {
      type: [Array, File],
      required: false,
      default() {
        return []
      },
    },

    amountTip: {
      type: Number || null,
      default: null,
    },

    currentTip: {
      type: Number || null,
      default: null,
    },

    showTipsInput: {
      type: Boolean,
      default: false,
    },

    transactionType: {
      type: String,
      default: '',
    },
  },

  setup() {
    const refImage = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refImage, () => {})

    return {
      refImage,
      inputImageRenderer,
    }
  },

  data() {
    return {
      transactionId: this.transactionInfo || '',
      imageFile: this.billing,
      imageError: false,
      showSuccessPage: false,
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      status: 'file/status',
      fileUrl: 'file/fileUrl',
      loading: 'file/loading',
      message: 'file/message',
      errorPayment: 'payment/errorPayment',
      paymentLoading: 'payment/loading',
    }),

    isBinanceID() {
      return this.transfer.value === this.$t('payment.USDT.labelBinanceUserID')
    },

    isInTrial() {
      return this.user?.isInTrial
    },

    amountValidate() {
      return !!(this.amount >= this.minAmount && this.amount <= this.maxAmount)
    },

    minAmount() {
      return 200
    },

    maxAmount() {
      return 100000
    },

    serviceCharge() {
      // return parseFloat(this.truncDigits(this.percentFee * this.amount)).toLocaleString('en-US')
      return this.amountFormat(this.percentFee * this.amount).toLocaleString(
        'en-US',
      )
    },

    percentFee() {
      return this.user?.data?.plans?.transferFee?.redotpay || 0
    },

    percentFeeTxt() {
      return `${(this.percentFee * 100).toFixed(2)}%`
    },

    methodFee() {
      return this.generalConfigs?.paymentGateFee?.redotpayGate || 0
    },

    methodFeeTxt() {
      return `${(this.methodFee * 100).toFixed(2)}%`
    },

    USDTFee() {
      return this.amountFormat(this.methodFee * this.amount).toLocaleString('en-US')
    },

    totalAmount() {
      const fee = this.amountFormat(this.percentFee * this.amount)
      const tax = this.amountFormat(this.taxRate * this.amount)
      const methodFee = this.amountFormat(this.methodFee * this.amount)
      // return parseFloat(this.truncDigits(this.amount + fee + tax)).toLocaleString('en-US')
      return (this.amount + fee + tax + methodFee + this.amountTip).toLocaleString('en-US')
    },
  },

  watch: {
    imageFile(val) {
      if (val) {
        this.upload(val)
        this.imageError = false
      }
    },
  },

  methods: {
    ...mapActions(['uploadFile']),
    ...mapPaymentActions(['createRecharge', 'getListTicket', 'getHistoryLimit']),

    async upload(file) {
      if (file) {
        await this.uploadFile(file)
        if (this.status) {
          this.toastSuccess(this.$t('payment.toastUploadSuccess'))
          this.$emit('set-url', this.fileUrl)
        } else {
          this.toastFailure(this.message)
        }
      }
    },

    handleClickPrev() {
      this.$emit('on-prev', {
        amount: this.amount,
        transactionId: this.transactionId,
        billing: this.imageFile,
        currentTip: this.currentTip,
        amountTip: this.amountTip,
        showTipsForAM: this.showTipsInput,
      })
    },

    async fetchListTicket() {
      const params = {
        types: [TICKET_TYPE.RECHARGE_USER_BALANCE, TICKET_TYPE.SETUP_COST],
        status: ['opening'],
      }
      await this.getListTicket({ params })
    },

    async fetchHistory() {
      const params = {
        page: 1,
        size: 5,
        types: [
          TRANSACTION_TYPE.RECHARGE_USER_BALANCE,
          TRANSACTION_TYPE.ADMIN_FIX_RECHARGE_MONEY,
          TRANSACTION_TYPE.SETUP_COST,
        ],
      }
      await this.getHistoryLimit(params)
    },

    submit() {
      if (!this.fileUrl) {
        this.imageError = true
      }

      this.$refs.formValidation.validate().then(async success => {
        if (success && this.fileUrl) {
          const params = {
            type: this.transactionType ? this.transactionType : TICKET_TYPE.RECHARGE_USER_BALANCE,
            details: {
              note: this.transactionId,
              amount: this.amount,
              paymentMethod: 'redotpay',
              coinType: this.paymentMethod.value,
              billingAttachment: this.fileUrl,
              coinNetwork: this.transfer.value,
              tipAMAmount: this.amountTip,
              // ...(this.isToggle
              //   && this.account && { adsAccountId: this.account?.value }),
            },
          }

          await this.createRecharge(params)
          if (this.isOnlyEcomdyPlatform) {
            this.gaTrackingUserAddFund(params.details.amount, PAYMENT_METHOD.REDOTPAY) // GA Tracking
          }
          if (this.errorPayment.message) {
            this.toastFailure(this.errorPayment.message)
          } else {
            this.showSuccessPage = true
            this.fetchListTicket()
            if (this.isSetupCostModel && this.hasStepGuide) {
              this.fetchHistory()
            }
            this.$emit('handleShowSuccess', this.showSuccessPage)
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_variables.scss';
  .step-number{
    min-width: 20px;
    height: 20px;
    background: $green;
    border-radius: 50px;
    line-height: 20px;
    color: white;
    font-size: 12px;
    text-align: center;
    margin: 2px 5px 0px 0px;
  }

  .point {
  margin-bottom: 4px;
  &::before {
    display: inline-block;
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #000;
    margin-right: 5px;
    margin-bottom: 3px;
  }
  &.warning {
    color: #f22548;
  }
}

.upload {
  cursor: pointer;
  background: #f5f5f7;
  border: 1px dashed rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  padding: 32px 0px;
  justify-content: center;

  img {
    max-width: 15px;
    margin-right: 5px;
  }
}

.text-back {
  color: #828287;
  margin-bottom: 24px;
}

.top-up-success {
  max-width: 410px;
  margin: 0 auto;
  margin-top: 42px;
}

.btn-back {
  color: rgb(22 33 62 / 76%) !important;
  background-color: rgba(0, 0, 0, 0.05) !important;
  padding: 11px 20px;
  font-size: 14px;
  font-weight: 600;
}

.wallet-content {
  margin: 32px 0px;
  border: 1px solid #eeeeee;
  background: #f5f5f7;
  border-radius: 16px;
  padding: 20px;
}

.horizontal-divide {
  margin: 20px 0px;
  border: 1px solid #e5e5e5;
}

.top-up-on-step {
  .line-center {
    display: none;
  }
}

.top-up-form-container {
  display: flex;

  .add-fund-form {
    width: 50%;
  }

  .line-center {
    margin: 0 1.5rem;
  }

  .summary-form {
    width: 50%;
  }

  @media (max-width: 1399px) {
    display: block;

    .add-fund-form {
      width: 100%;
    }

    .line-center {
      display: none;
    }

    .summary-form {
      width: 100%;
    }
  }
}
.total-amount{
  color: #27a27a;
  font-size: 20px;
}

.border-content {
  border-radius: 0px 0px 24px 24px !important;
}
</style>
